import { Action, createReducer, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { ServiceItem } from './service-item.model';
import * as ServiceItemActions from './service-item.actions';
import * as fromServiceItem from './service-item.reducer';
import { PostingType } from '../../lookups';

export const serviceItemsFeatureKey = 'serviceItems';

export interface State extends EntityState<ServiceItem> {
    // additional entities state properties
    ServiceItemPostingTypes: PostingType[];
}

export const adapter: EntityAdapter<ServiceItem> = createEntityAdapter<
    ServiceItem
>({ selectId: (model: ServiceItem) => model.SIListID });

export const initialState: State = adapter.getInitialState({
    // additional entity state properties
    ServiceItemPostingTypes: []
});

const serviceItemReducer = createReducer(
    initialState,
    on(ServiceItemActions.addServiceItem, (state, action) =>
        adapter.addOne(action.serviceItem, state)
    ),
    on(ServiceItemActions.upsertServiceItem, (state, action) =>
        adapter.upsertOne(action.serviceItem, state)
    ),
    on(ServiceItemActions.addServiceItems, (state, action) =>
        adapter.addMany(action.serviceItems, state)
    ),
    on(ServiceItemActions.upsertServiceItems, (state, action) =>
        adapter.upsertMany(action.serviceItems, state)
    ),
    on(ServiceItemActions.updateServiceItem, (state, action) =>
        adapter.updateOne(action.serviceItem, state)
    ),
    on(ServiceItemActions.updateServiceItems, (state, action) =>
        adapter.updateMany(action.serviceItems, state)
    ),
    on(ServiceItemActions.deleteServiceItem, (state, action) =>
        adapter.removeOne(action.id, state)
    ),
    on(ServiceItemActions.deleteServiceItems, (state, action) =>
        adapter.removeMany(action.ids, state)
    ),
    on(ServiceItemActions.loadServiceItems, (state, action) =>
        adapter.setAll(action.serviceItems, state)
    ),
    on(ServiceItemActions.clearServiceItems, state => adapter.removeAll(state)),
    on(ServiceItemActions.loadServiceItemPostingTypes, (state, action) => ({
        ...state,
        ServiceItemPostingTypes: action.ServiceItemPostingTypes
    }))
);

export function reducer(state: State | undefined, action: Action) {
    return serviceItemReducer(state, action);
}
